module.exports = __webpack_public_path__ + "static/mental_health_banner_m@2x-4277dd686b2c5e2418c3de3187073213.jpg";